export var PROGRESS_BAR_HEIGHT = 8;
export var PROGRESS_BAR_BORDER_WIDTH = 1;
export var PROGRESS_BAR_MIN_WIDTH = 112;
export var PROGRESS_BAR_BORDER_RADIUS = 1000;
export var PROGRESS_BAR_THRESHOLD_HEIGHT = 12;
export var PROGRESS_BAR_THRESHOLD_WIDTH = 2;
export var formatProgress = function formatProgress(amount) {
  return parseFloat((amount * 100).toPrecision(3));
};